import React from "react";
import { Box, Typography } from "@mui/material";
import { APP_FOOTER_TEXT } from "../config";

export default function SkeletonFooter({ currentYear }) {
  return (
    <Box component="footer" sx={{ mt: "auto", px: { xs: 1.5, sm: 2, md: 3 }, pb: 2.2, pt: 1.35 }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 58, py: 1.35, px: { xs: 1.8, sm: 2.2 }, bgcolor: "background.paper", border: "1px solid", borderColor: "divider", borderRadius: 999, boxShadow: "0 8px 24px rgba(17, 24, 39, 0.05)" }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
          {APP_FOOTER_TEXT} © {currentYear}
        </Typography>
      </Box>
    </Box>
  );
}
